<template>
    <textarea v-model="model"
        class="form-control form-control-lg"
           :class="{ 'is-invalid' : hasError }"
           :style="hasError ? { 'border-width': '1px' } : {}" />   
</template>

<script>
    export default {
        name: 'Textarea',
        props: {
            value: String,
            hasError: Boolean
        },
        computed:{
            model: {
                get() {
                    return this.value
                },
                set(val) {
                    this.$emit('input', val)
                }
            }
        }
    }
</script>